import { render } from "./MemberManageView.vue?vue&type=template&id=0b409644&scoped=true&ts=true"
import script from "./MemberManageView.vue?vue&type=script&lang=ts"
export * from "./MemberManageView.vue?vue&type=script&lang=ts"

import "./MemberManageView.vue?vue&type=style&index=0&id=0b409644&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b409644"]])

export default __exports__